import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Daundrailwaystationtoshirdibusonrent() {



  const cardData =
  {
    keyword: 'Daund Railway Station to Shirdi Bus On Rent',
    heading: 'Sanavi Travels: Daund Railway Station to Shirdi Bus On Rent',
    headingDescription: 'Sanavi Travels offers reliable Daund Railway Station to Shirdi Bus On Rent, providing safe, comfortable, and hassle-free transportation for pilgrims, families, and groups traveling from Daund to the holy town of Shirdi. Our fleet of well-maintained AC and non-AC buses ensures spacious seating, smooth rides, and a stress-free journey. With professional drivers, flexible one-way and round-trip bus packages, transparent pricing, railway pickup from Daund, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and convenient travel. We cover major attractions including Sai Baba Temple, Dwarkamai, Chavadi, Lendi Baug, and Shani Shingnapur, making us a trusted choice for Daund to Shirdi bus rentals for group travel, family trips, and religious tours.',

    top: 'Top Places to Visit in Shirdi with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shirdi Sai Baba Temple",
    "description": "Shirdi Sai Baba Temple is the primary attraction of Shirdi, dedicated to the revered saint Sai Baba. Devotees from across India and abroad visit to seek blessings, peace, and spiritual guidance. The temple complex is well-organized, making darshan and participation in aartis seamless."
  },
  {
    "title": "Sai Baba Samadhi Mandir",
    "description": "The Samadhi Mandir is the heart of Shirdi, housing the final resting place of Sai Baba. Pilgrims offer prayers and experience a deep sense of devotion and calm. It is considered the spiritual center of the town."
  },
  {
    "title": "Dwarkamai",
    "description": "Dwarkamai is the sacred mosque where Sai Baba lived for many years and performed miracles. The continuously burning dhuni (sacred fire) symbolizes faith and protection, attracting devotees for prayers and blessings."
  },
  {
    "title": "Chavadi",
    "description": "Chavadi is the historic place where Sai Baba used to spend alternate nights. On Thursdays and special occasions, ceremonial processions are held, preserving the traditional practices associated with Sai Baba’s life."
  },
  {
    "title": "Lendi Baug",
    "description": "Lendi Baug is a serene garden where Sai Baba spent time in meditation and care of plants. It features the sacred Nanda Deep lamp, which has been continuously lit for decades, offering a peaceful environment for devotees."
  },
  {
    "title": "Khandoba Temple",
    "description": "Khandoba Temple is historically significant as the site where Sai Baba was first welcomed to Shirdi. The temple remains an important landmark, reflecting the early days of Sai Baba’s presence in the town."
  },
  {
    "title": "Sai Heritage Village",
    "description": "Sai Heritage Village is a devotional theme park depicting scenes from Sai Baba’s life using statues and traditional settings. It helps visitors understand Sai Baba’s teachings in a visual and engaging manner."
  },
  {
    "title": "Abdul Baba’s Cottage",
    "description": "Abdul Baba’s Cottage commemorates one of Sai Baba’s closest disciples. The site reflects the deep spiritual bond between Sai Baba and his followers and is visited for inspiration and blessings."
  },
  {
    "title": "Shani Shingnapur",
    "description": "Located nearby, Shani Shingnapur is famous for the Lord Shani temple and its open-door village tradition. Devotees often visit Shani Shingnapur along with Shirdi for a holistic spiritual experience."
  },
  {
    "title": "Wet N Joy Water Park",
    "description": "Wet N Joy Water Park offers recreational activities such as water rides, wave pools, and family entertainment. It provides a refreshing break for pilgrims traveling to Shirdi."
  }
]
,



"services": [
  {
    "name": "Daund to Shirdi Cabs",
    "description": "Daund to Shirdi Cabs provides reliable and comfortable transportation for pilgrims, families, and tourists traveling from Daund to Shirdi. Well-maintained, air-conditioned vehicles with spacious seating ensure a relaxed journey. Experienced chauffeurs handle highway driving, traffic, and route planning efficiently, offering punctual pickups and drop-offs. Ideal for one-way trips, round trips, and religious tours, this service ensures safety, convenience, and a stress-free travel experience for everyone."
  },
  {
    "name": "Daund Shirdi Taxi Service",
    "description": "Daund Shirdi Taxi Service offers professional taxi solutions for passengers traveling between Daund and Shirdi. Fully air-conditioned taxis with trained drivers ensure comfortable and smooth rides. Suitable for families, groups, and solo travelers, this service emphasizes punctuality, safety, and convenience for both short and long journeys."
  },
  {
    "name": "AC Cab Daund to Shirdi",
    "description": "AC Cab Daund to Shirdi ensures a cool and comfortable journey throughout the trip. Air-conditioned vehicles with clean interiors and comfortable seating provide a pleasant travel experience. Skilled chauffeurs manage routes, traffic, and highway driving safely, making this service ideal for families, corporate travelers, and tourists visiting Shirdi."
  },
  {
    "name": "Affordable Shirdi Cab",
    "description": "Affordable Shirdi Cab offers budget-friendly travel options from Daund to Shirdi without compromising comfort or safety. Clean, air-conditioned vehicles with experienced drivers ensure a smooth journey at economical pricing. Perfect for students, families, and small groups seeking reliable and affordable transport for religious trips or leisure travel."
  },
  {
    "name": "Chauffeur Driven Cab Shirdi",
    "description": "Chauffeur Driven Cab Shirdi provides a stress-free travel experience with professional drivers managing navigation, traffic, and scheduling. Spacious air-conditioned vehicles allow passengers to relax throughout the journey. Ideal for families, business travelers, and pilgrims, this service emphasizes safety, punctuality, and passenger comfort."
  },
  {
    "name": "Best Daund Shirdi Cab",
    "description": "Best Daund Shirdi Cab delivers a premium and dependable travel experience. Well-maintained vehicles with trained chauffeurs ensure a smooth and comfortable ride. Fully air-conditioned cabs make long-distance travel enjoyable, while punctual service and safety measures provide peace of mind for families, tourists, and corporate travelers alike."
  },
  {
    "name": "Family Cab Shirdi",
    "description": "Family Cab Shirdi is designed for safe, comfortable, and convenient family travel from Daund to Shirdi. Spacious air-conditioned cabs with ample luggage space accommodate all family members comfortably. Experienced drivers prioritize smooth driving and flexibility, making this service ideal for family pilgrimages and group trips."
  },
  {
    "name": "Tourist Cab Shirdi",
    "description": "Tourist Cab Shirdi caters to travelers visiting Shirdi and nearby attractions. Fully air-conditioned vehicles with professional chauffeurs ensure a comfortable and organized travel experience. Suitable for tourists, families, and groups, this service focuses on convenience, safety, and punctuality during sightseeing or religious tours."
  },
  {
    "name": "One Way Cab Shirdi",
    "description": "One Way Cab Shirdi offers a cost-effective solution for passengers traveling from Daund to Shirdi without a return journey. Comfortable, air-conditioned cabs with skilled chauffeurs ensure safe and timely travel. Ideal for business travelers, pilgrims, and tourists looking for flexible one-way transport options."
  },
  {
    "name": "Round Trip Cab Shirdi",
    "description": "Round Trip Cab Shirdi provides convenient transportation for passengers planning to return to Daund after visiting Shirdi. Fully air-conditioned vehicles with experienced drivers ensure smooth, comfortable, and timely journeys. Perfect for families, corporate travelers, and tour groups seeking hassle-free round trips."
  },
  {
    "name": "Railway Pickup Daund",
    "description": "Railway Pickup Daund ensures passengers arriving at Daund railway station are transported safely and comfortably to Shirdi. Professional drivers monitor train schedules for timely pickups and provide smooth, air-conditioned cab rides. Suitable for families, solo travelers, and group pilgrims."
  },
  {
    "name": "Online Cab Booking Daund",
    "description": "Online Cab Booking Daund allows customers to easily book cabs from Daund to Shirdi anytime, anywhere. Users can select cab type, pickup location, travel date, and trip preferences with instant confirmation. Fully air-conditioned vehicles with professional chauffeurs provide reliable, safe, and convenient travel planning."
  },
  {
    "name": "Sai Darshan Cab",
    "description": "Sai Darshan Cab offers specialized transportation services for pilgrims visiting the Sai Baba temple in Shirdi. Comfortable, air-conditioned vehicles with trained drivers ensure timely pickups, safe travel, and a stress-free journey. Ideal for families, groups, and solo pilgrims seeking reliable temple transport."
  },
  {
    "name": "Outstation Cab Daund",
    "description": "Outstation Cab Daund provides reliable long-distance travel solutions from Daund to Shirdi and other nearby destinations. Well-maintained, air-conditioned vehicles with skilled chauffeurs ensure smooth highway travel, punctual service, and flexible travel plans. Suitable for families, tourists, and corporate groups seeking convenient outstation transport."
  },
  {
    "name": "Shirdi Travel Taxi",
    "description": "Shirdi Travel Taxi delivers comprehensive travel solutions for journeys from Daund to Shirdi. Comfortable AC cabs with experienced chauffeurs provide safe, punctual, and enjoyable rides. Perfect for families, tourists, and corporate travelers, this service emphasizes reliability, convenience, and passenger satisfaction for religious and leisure trips."
  }
],
"tableData": [
  ["Daund to Shirdi Cabs", "Daund Shirdi Taxi Service"],
  ["AC Cab Daund to Shirdi", "Affordable Shirdi Cab"],
  ["Chauffeur Driven Cab Shirdi", "Best Daund Shirdi Cab"],
  ["Family Cab Shirdi", "Tourist Cab Shirdi"],
  ["One Way Cab Shirdi", "Round Trip Cab Shirdi"],
  ["Railway Pickup Daund", "Online Cab Booking Daund"],
  ["Sai Darshan Cab", "Outstation Cab Daund"],
  ["Shirdi Travel Taxi", "—"]
]
,

"whychoose": [
  {
    "WhyChooseheading": "Daund Railway Station to Shirdi Bus On Rent with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels provides reliable and comfortable bus rental services from Daund Railway Station to Shirdi, perfect for group travel, pilgrimages, and family trips."
  },
  {
    "WhyChooseheading": "Well-Maintained and Comfortable Buses",
    "WhyChoosedescription": "Travel in clean, air-conditioned, and regularly serviced buses to ensure a smooth and enjoyable journey from Daund Railway Station to Shirdi."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, professional, and familiar with the Daund to Shirdi route, ensuring safe and timely travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers clear and upfront pricing for Daund Railway Station to Shirdi bus rentals, inclusive of fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bus bookings, travel queries, and itinerary planning."
  },
  {
    "WhyChooseheading": "Flexible Bus Rental Options",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized bus rental packages based on your Daund Railway Station to Shirdi travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Daund Railway Station to Shirdi bus rentals."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental from Daund Railway Station to Shirdi?',
    answer: 'Yes, Sanavi Travels offers reliable and comfortable bus rental services for Daund Railway Station to Shirdi trips.'
  },
  {
    question: 'How can I book a bus from Daund Railway Station to Shirdi?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for this route?',
    answer: 'Sanavi Travels provides air-conditioned and well-maintained buses suitable for group travel from Daund Railway Station to Shirdi.'
  },
  {
    question: 'Are the drivers experienced on the Daund to Shirdi route?',
    answer: 'Yes, our professional drivers are licensed, courteous, and familiar with the Daund to Shirdi journey.'
  },
  {
    question: 'Can I customize my Daund Railway Station to Shirdi travel itinerary?',
    answer: 'Absolutely. You can customize stops, timing, and duration according to your group’s preferences.'
  },
  {
    question: 'Is the bus rental service available 24x7?',
    answer: 'Yes, Sanavi Travels provides round-the-clock support for bus rentals from Daund Railway Station to Shirdi.'
  },
  {
    question: 'Are the buses sanitized before trips?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'What payment options are available?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Daund to Shirdi bus trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Patil',
    feedback: 'Rented a bus from Daund Railway Station to Shirdi. Comfortable journey, professional driver, and excellent service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Kavita More',
    feedback: 'Great experience with Sanavi Travels. The bus was clean, punctual, and the driver was very professional.',
    rating: 5
  }
];














































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Daund Railway Station to Shirdi Bus On Rent - Sanavi Travels",
  "description": "Sanavi Travels provides AC and chauffeur-driven buses from Daund Railway Station to Shirdi for Sai Darshan, family trips, tourist travel, and group tours. Affordable, reliable, and convenient Daund to Shirdi bus rental with online booking.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1200"
  }
};






  return (
    <div>

<Helmet>
  <title>
    Daund Railway Station to Shirdi Bus On Rent | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book AC and chauffeur-driven buses from Daund Railway Station to Shirdi with Sanavi Travels. Perfect for Sai Darshan, family trips, group travel, and tourist trips. Affordable and reliable bus service with railway pickup and online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/93.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Daundrailwaystationtoshirdibusonrent;